export default function getInitialState(initialState = {}) {
  return {
    ...initialState
  };
}
